import React, { useRef } from "react";
import NewPackingList from "../../common/components/newPakingList/NewPackingList";
import FormHeader from "../../common/components/FormHeader/FormHeader";
import Strings from "../../common/res/String";
import Sidebar from "../../common/components/Sidebar/sidebar";
import { useLocation } from "react-router-dom";

export default function NewPackingListScreen() {
  const { state } = useLocation();

  const scrollRef = useRef(null);
  return (
    <>
      <section className="agent_management_main_section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-2 p-0 m-0">
              <Sidebar />
            </div>
            <div className="col-lg-10 p-0 m-0">
              <div className="new_packing_list_main_container" ref={scrollRef}>
                <div className="new_packing_list_entry_form" divref={scrollRef}>

                  {state?.id ? (
                    <>
                      <FormHeader header="EDIT PACKING LIST" />

                    </>
                  ) : (
                    <>
                      <FormHeader header={Strings.parkingListManagement} />
                    </>
                  )}

                  <NewPackingList />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >
    </>
  );
}
